export default __webpack_public_path__ + "static/media/book-2-black.a60e931c.svg";